import { RequestStatus } from 'dg-web-shared/lib/hooks/ServerStateHooks';
import { ParkingaboVehicle } from 'dg-web-shared/common/models/Vehicle';
import { ParkingaboUser } from '../shared/ParkingaboModels';
import { ParkingaboProductListItem } from '../shared/ParkingaboProductModels';
import { useParamOperatorExternalId } from '../components/CustomerProvider.tsx';

export interface Vehicles {
    data: ParkingaboVehicle[];
    status: RequestStatus;
    refetch: () => void;
}

export interface CustomerContextData {
    user: ParkingaboUser;
    linkedUserCount: number;
    refetchUser: () => void;
    products: ParkingaboProductListItem[];
    refetchProducts: () => void;
    vehicles: Vehicles;
    logout: () => void;
}

export type LoggedInRouteCompProps = {
    logout: () => void;
    linkedUsers: ParkingaboUser[];
    refetchUsers: () => void;
};

export function useParkingaboAuthedPathGeneration() {
    const operatorExternalId = useParamOperatorExternalId();

    function generateAuthedParkingaboPath(path: string): string {
        return `/${operatorExternalId}/` + path;
    }
    return generateAuthedParkingaboPath;
}
